import { BookOpen, FileText, House, MessageCircle, ShieldCheck, UserRound } from "lucide-react";
import type { ViewMode } from "@/hooks/useViewMode";

export interface Tab {
  to: string;
  label: string;
  icon: typeof House;
  /** Other paths that belong to this tab's stack. */
  also?: string[];
}

/**
 * Five destinations, the same for prospects and clients (a SwiftUI TabView on
 * iPhone, a sidebar on iPad and the desktop web). Only the Plan tab's label
 * and icon change once a policy is active, so nothing moves.
 */
export function tabsFor(mode: ViewMode): Tab[] {
  return [
    { to: "/", label: "Home", icon: House, also: ["/appointments", "/team", "/journey"] },
    mode === "client" ? { to: "/plan", label: "Policy", icon: ShieldCheck } : { to: "/plan", label: "Plan", icon: FileText },
    { to: "/learn", label: "Learn", icon: BookOpen },
    { to: "/messages", label: "Messages", icon: MessageCircle },
    { to: "/profile", label: "Profile", icon: UserRound },
  ];
}

export function isActive(tab: Tab, pathname: string): boolean {
  const matches = (p: string) => (p === "/" ? pathname === "/" : pathname === p || pathname.startsWith(`${p}/`));
  return matches(tab.to) || (tab.also ?? []).some(matches);
}
